import axios from 'axios'

class ProductionSitesQueries {
    fetchProductionSites(params) {
        return axios.get('/production-sites/production-sites', { params })
    }

    fetchProductionSitesBase(params) {
        return axios.get('/production-sites/production-sites-base', { params })
    }

    fetchProductionSite(id) {
        return axios.get(`/production-sites/production-sites/${id}`)
    }

    createProductionSite(payload) {
        return axios.post('/production-sites/production-sites', payload)
    }

    updateProductionSite(id, payload) {
        return axios.put(`/production-sites/production-sites/${id}`, payload)
    }

    deleteProductionSite(id) {
        return axios.delete(`/production-sites/production-sites/${id}`)
    }

    fetchPrinters() {
        return axios.get('/print-manager/dicts/printers')
    }

    fetchProductionSiteTypes() {
        return axios.get('/production-sites/production-site-types')
    }

    fetchProductionSiteGroups(params) {
        return axios.get('/production-sites/production-site-groups', { params })
    }

    fetchAllowedReportItemTypes() {
        return axios.get('/reports/reports/dicts/report-item-types')
    }

    fetchMachines(params) {
        return axios.get('/machines/machines', { params })
    }
}

export default new ProductionSitesQueries()
